<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="shipping-history-detail">
      <Title class="_title" :jpn="t('履歴')" />
      <HistoryHeader />
    </div>
    <div class="shipping-list" v-if="shippedList && shippedList.list">
      <div class="shipping-list-detail" v-for="(cards,date) in shippedList.list" :key="date">
        <GreenGradationButton
          :isHeading="true" class="green-button"
          :text="`${t('発送済み一覧')}: ${cards.date}`"
          :subText="`${t('追跡番号')}: ${cards.delivery_code}`"
          :url = "cards.url" />
        <CardList
          :cardList="cards.cards"
        />
      </div>
      <BoxPager
          v-if="
            shippedList &&
            shippedList.page &&
            shippedList.page.pages
          "
          class="box-pager"
          :totalPageCount="shippedList.page.all_page"
          :currentPageCount="shippedList.page.page"
          :dispBoxCount="shippedList.page.pages.length"
          :pages="shippedList.page.pages"
          @handlePagerClick="changeCurrentPageCount"
          @handleSquareBtnClick="changeCurrentPageCount"
        />
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';
import HistoryHeader from '@/components/molecules/HistoryHeader.vue';
import GreenGradationButton from '@/components/atoms/GreenGradationButton.vue';
import CardList from '@/components/organisms/CardList.vue';
import BoxPager from '@/components/organisms/BoxPager.vue';

export default {
  name: 'UndecidedDetail',
  mixins: [t],

  components: {
    BaseTemplate,
    Title,
    HistoryHeader,
    GreenGradationButton,
    CardList,
    BoxPager,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      shippedList: 'pending/shippedList',
    }),
    translatedBackText() {
      return this.t('一覧に戻る');
    },
  },

  created() {
    const pageNumber = 1;
    this.$store.dispatch('pending/setShippedList', { pageNumber });
  },
};
</script>

<style lang="scss" scoped>
.shipping-history-detail{
  position: relative;
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding: 30px 0 0 0;
  margin: 0px auto;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  @media screen and (min-width:767px){
    max-width: 580px;
  }
  @media screen and (min-width:1023px){
    max-width: 1000px;
  }
  .button-area{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    .square-button{
      width: 200px;
      height: 40px;
    }
  }
  .border-area {
    margin: 30px 10px 0;
    padding: 10px 0;
    color: $white;
  }
}
.shipping-list{

  .shipping-list-detail{
    max-width: 900px;
    margin: 0 auto;
    .green-button{
      width: 100%;
      width: auto;
    }
  }
}
</style>
